export default "<h1>Background Rules 背景规则</h1>\n<p>背景填充配色规则</p>\n"